import styled from '@emotion/styled'

export const ReceiptsActionsWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ReceiptsLeftActionsWrapper = styled.div`
  display: flex;
  align-items: center;
`
